import CustomTab from "../../../components/TabContainer/CustomTab";
import { ACTIONS, USERTYPES } from "../../../constants/Constants";
import FirmAdminUserList from "../../AdminUser/FirmAdminUserList";
import SupervisorList from "../../Supervisor/SupervisorList";
import FirmDoctorList from "../FirmDoctor/FirmDoctorList";
import FirmTechnicianList from "../FirmTechnician/FirmTechnicianList";
import TypistList from "../Typist/TypistList";
import AutoAssignmentAccess from "../components/ConfigureSettings/AutoAssignmentAccess";
import ConfigureClientAccess from "../components/ConfigureSettings/ConfigureClientAccess";
import ConfigureRadiologistAccess from "../components/ConfigureSettings/ConfigureRadiologistAccess";
import ConfigureSettings from "../components/ConfigureSettings/ConfigureSettings";
import ConfigureSupervisorAccess from "../components/ConfigureSettings/ConifgureSupervisorAccess";
import OtherSettings from "../components/ConfigureSettings/OtherSettings";
import ContactDetailsSection from "../components/ContactDetailsSection/ContactDetailsSection";
import HeaderFileCheck from "../components/HeaderFileChecks/HeaderFileChecks";
import HospitalDetailsSection from "../components/HospitalDetailsSection/HospitalDetailsSection";
import HospitalSettings from "../components/HospitalSettings/HospitalSettings";
import PasswordProtectedSection from "../components/PasswordProtectionSection/PasswordProtectionSection";
import PriorsStudiesSettings from "../components/PriorsSettings/PriorsStudiesSettings";
import { passwordProtectedOptions } from "./InitialData";
import ConfigurePacs from "../components/ConfigurePacsSection/ConfigurePacs";
import ConfigurePacsAccess from "../components/ConfigurePacsSection/ConfigurePacsAccess";

export const getFirmTabs = (
  handleCancel,
  setTotalTabs,
  roles,
  values,
  errorContactState,
  t,
  ownFirm,
  handleChange,
  handleClearImage,
  setIsHeaderFileDeleted,
  isHeaderFileDeleted,
  setIsFooterFileDeleted,
  isFooterFileDeleted,
  setIsSignatureFile2Deleted,
  isSignatureFile2Deleted,
  setIsSignatureFile3Deleted,
  isSignatureFile3Deleted,
  handleBlur,
  errors,
  touched,
  state,
  action,
  editConfigurationSetting,
  choiceGroupStyles,
  headerImageValue,
  footerImageValue,
  signature2ImageValue,
  signature3ImageValue,
  modalityList,
  modalityWithSubModalityList,
  selectedCountry,
  setSelectedCountry,
  selectedState,
  setSelectedState,
  selectedCity,
  setSelectedCity,
  historyModalityList,
  firmGlobalErrorState,
  viewWarningOnly,
  isMinimalAccount,
  headerImageFileName,
  setHeaderImageFileName,
  footerImageFileName,
  setFooterImageFileName,
  selectedModalityAndSubModality,
  setSelectedModalityAndSubModality,
  firmType,
  selectedRadiologistMap,
  setSelectedRadiologistMap,
  radiologistList,
  setRadiologistList,
  checkAllRadiologist,
  setCheckAllRadiologist,
  selectedSupervisorMap,
  setSelectedSupervisorMap,
  supervisorList,
  setSupervisorList,
  checkAllSupervisor,
  setCheckAllSupervisor,
  tabStatusInitialValue,
  setTabStatusInitialValue,
  firmListForProviders,
  hospitalCheckList,
  setHospitalCheckList,
  pacsNodeList,
  setPacsNodeList,
  availablePacsList, 
  setAvailablePacsList,
  checkAllPacs, 
  setCheckAllPacs,
  selectedPacsList, 
  setSelectedPacsList,
  showPriorsStudiesList,
  setShowPriorsStudiesList
) => {
  let tabCount = 1;
  let enterprise =
    process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" ||
    process.env.REACT_APP_ENTERPRISE_PLATFORM == true
      ? true
      : false;

  let tabs = [];

  const firmDetails = {
    selectedKey: tabCount.toString(),
    tabName: t("hospital.hospital-details"),
    tabKeyContain: (
      <CustomTab
        orderNumber={tabCount.toString()}
        subtitle={
          ownFirm || roles[0] === USERTYPES.ADMIN
            ? t("sub-title.firm.firm-details")
            : t("sub-title.client.client-details")
        }
        tabName={
          enterprise
            ? t("hospital.hospital-details")
            : firmType === 1
            ? t("hospital.provider-details")
            : ownFirm || roles[0] === USERTYPES.ADMIN
            ? t("hospital.firm-details")
            : t("hospital.client-details")
        }
        iconName={errorContactState.tabStatusInitialValue.tab1Status.value}
        iconColor={errorContactState.tabStatusInitialValue.tab1Status.color}
        action={action}
      />
    ),
    tabValueContain: (
      <HospitalDetailsSection
        key={(tabCount++).toString()}
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        touched={touched}
        state={state}
        action={action}
        errorState={errorContactState.hospitalDetails}
        ownFirm={ownFirm}
        editConfigurationSetting={editConfigurationSetting}
        roles={roles}
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        selectedState={selectedState}
        setSelectedState={setSelectedState}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        firmType={firmType}
      />
    ),
  };
  tabs.push(firmDetails);

  if (roles[0] != USERTYPES.SUPERVISOR) {
    const contactDetails = {
      selectedKey: tabCount,
      tabName: `${t("hospital.contact-details")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.contact-details")}
          subtitle={
            ownFirm || roles[0] === USERTYPES.ADMIN
              ? t("sub-title.firm.contact-details")
              : t("sub-title.client.contact-details")
          }
          iconName={errorContactState.tabStatusInitialValue.tab2Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab2Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <ContactDetailsSection
          key={tabCount++}
          values={values}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          state={state}
          action={action}
          errorContactState={errorContactState}
          ownFirm={ownFirm}
          editConfigurationSetting={editConfigurationSetting}
          roles={roles}
        />
      ),
    };
    tabs.push(contactDetails);
  }

  if (
    (action === ACTIONS.ADD ||
      ((action === ACTIONS.EDIT || action === ACTIONS.VIEW) &&
        (roles[0] !== USERTYPES.FIRMADMIN ||
          roles[0] === USERTYPES.FIRMTECHNICIAN)) ||
      (roles[0] === USERTYPES.FIRMADMIN && ownFirm)) &&
    roles[0] != USERTYPES.SUPERVISOR &&
    roles[0] != USERTYPES.FIRMDOCTOR
  ) {
    const passwordProtection = {
      selectedKey: tabCount,
      tabName: `${t("hospital.password-protected-text")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.password-protected-text")}
          subtitle={t("sub-title.firm.password-protect")}
          iconName={errorContactState.tabStatusInitialValue.tab3Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab3Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <PasswordProtectedSection
          key={tabCount++}
          choiceGroupStyles={choiceGroupStyles}
          values={values}
          passwordProtectedOptions={passwordProtectedOptions()}
          state={state}
          action={action}
          ownFirm={ownFirm}
          editConfigurationSetting={editConfigurationSetting}
        />
      ),
    };
    tabs.push(passwordProtection);
  }

  if (
    (action === ACTIONS.ADD ||
      action === ACTIONS.EDIT ||
      action === ACTIONS.VIEW) &&
    ((ownFirm && roles[0] === USERTYPES.FIRMADMIN) ||
      roles[0] === USERTYPES.ADMIN ||
      roles[0] === USERTYPES.FIRMTECHNICIAN) &&
    roles[0] != USERTYPES.FIRMDOCTOR &&
    !values.isClientWarning
  ) {
    const templateSettings = {
      selectedKey: tabCount,
      tabName: `${t("hospital.template-setting")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.template-setting")}
          subtitle={t("sub-title.firm.template-setting")}
          iconName={errorContactState.tabStatusInitialValue.tab4Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab4Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <HeaderFileCheck
          key={tabCount++}
          headerName={t("hospital.custom-header-file-check")}
          values={values}
          headerImageValue={headerImageValue}
          footerImageValue={footerImageValue}
          handleClearImage={handleClearImage}
          setIsHeaderFileDeleted={setIsHeaderFileDeleted}
          isHeaderFileDeleted={isHeaderFileDeleted}
          setIsFooterFileDeleted={setIsFooterFileDeleted}
          isFooterFileDeleted={isFooterFileDeleted}
          state={state}
          action={action}
          ownFirm={ownFirm}
          editConfigurationSetting={editConfigurationSetting}
          headerImageFileName={headerImageFileName}
          setHeaderImageFileName={setHeaderImageFileName}
          footerImageFileName={footerImageFileName}
          setFooterImageFileName={setFooterImageFileName}
          handleChange={handleChange}
        />
      ),
    };
    tabs.push(templateSettings);
  }

  if (
    (action === ACTIONS.ADD ||
      ((action === ACTIONS.EDIT || action === ACTIONS.VIEW) &&
        roles[0] !== USERTYPES.FIRMADMIN) ||
      (roles[0] === USERTYPES.FIRMADMIN && ownFirm)) &&
    roles[0] != USERTYPES.SUPERVISOR
  ) {
    const settings = {
      selectedKey: tabCount,
      tabName: `${t("hospital.settings")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.settings")}
          subtitle={t("sub-title.firm.general-setting")}
          iconName={errorContactState.tabStatusInitialValue.tab6Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab6Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <HospitalSettings
          key={tabCount++}
          choiceGroupStyles={choiceGroupStyles}
          values={values}
          errorState={errorContactState.settings}
          handleChange={handleChange}
          handleClearImage={handleClearImage}
          setIsSignatureFile2Deleted={setIsSignatureFile2Deleted}
          isSignatureFile2Deleted={isSignatureFile2Deleted}
          setIsSignatureFile3Deleted={setIsSignatureFile3Deleted}
          isSignatureFile3Deleted={isSignatureFile3Deleted}
          handleBlur={handleBlur}
          touched={touched}
          state={state}
          action={action}
          errors={errors}
          ownFirm={ownFirm}
          editConfigurationSetting={editConfigurationSetting}
          modalityList={modalityList}
          roles={roles}
          signature2ImageValue={signature2ImageValue}
          signature3ImageValue={signature3ImageValue}
          firmGlobalErrorState={firmGlobalErrorState}
        />
      ),
    };
    tabs.push(settings);
  }

  if (action === ACTIONS.ADD && roles[0] == USERTYPES.FIRMADMIN && ownFirm) {
    const configureAutoAssignmentAccess = {
      selectedKey: tabCount,
      tabName: t("hospital.auto-assignment-settings"),
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.auto-assignment-settings")}
          subtitle="Manage your auto assignment settings"
          iconName={errorContactState.tabStatusInitialValue.tab13Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab13Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <AutoAssignmentAccess
          key={tabCount++}
          firmId={values.id}
          action={action}
          values={values}
          errorState={errorContactState.autoAssignSettings}
          handleChange={handleChange}
          handleCancel={handleCancel}
          handleBlur={handleBlur}
          touched={touched}
          state={state}
          modalityList={modalityList}
          modalityWithSubModalityList={modalityWithSubModalityList}
          historyModalityList={historyModalityList}
          selectedModalityAndSubModality={selectedModalityAndSubModality}
          setSelectedModalityAndSubModality={setSelectedModalityAndSubModality}
        />
      ),
    };
    tabs.push(configureAutoAssignmentAccess);
  }

  if (roles[0] === USERTYPES.ADMIN && !isMinimalAccount && (action === ACTIONS.VIEW || action === ACTIONS.EDIT)) {
    const showPriorsForConnections = {
      selectedKey: tabCount,
      tabName: `t("hospital.show-priors-settings")`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount++}
          tabName={t("hospital.show-priors-settings")}
          iconName={errorContactState.tabStatusInitialValue.tab18Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab18Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <PriorsStudiesSettings
          showPriorsStudiesList={showPriorsStudiesList}
          setShowPriorsStudiesList={setShowPriorsStudiesList}
          firmId={values.id}
          action={action}
          values={values}
        />
      ),
    };
    tabs.push(showPriorsForConnections);
  }

  if (
    (action === ACTIONS.VIEW || action === ACTIONS.EDIT) &&
    roles[0] === USERTYPES.ADMIN &&
    !isMinimalAccount &&
    !values.isClientWarning &&
    !ownFirm
  ) {
    const firmTechnician = {
      selectedKey: tabCount,
      tabName: `{t("hospital.hospital-users")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount++}
          tabName={
            roles[0] === USERTYPES.ADMIN
              ? t("hospital.firm-technicians")
              : t("hospital.client-techinicians")
          }
          iconName={errorContactState.tabStatusInitialValue.tab7Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab7Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <FirmTechnicianList fullLength={true} firmId={values.id} />
      ),
    };

    tabs.push(firmTechnician);
  }

  if (
    (action === ACTIONS.VIEW || action === ACTIONS.EDIT) &&
    roles[0] === USERTYPES.ADMIN &&
    !values.isClientWarning &&
    !isMinimalAccount &&
    !ownFirm
  ) {
    const fimrDoctors = {
      selectedKey: tabCount,
      tabName: `{t("hospital.hospital-doctors")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount++}
          tabName={
            roles[0] === USERTYPES.ADMIN
              ? t("hospital.firm-doctors")
              : t("hospital.client-doctors")
          }
          iconName={errorContactState.tabStatusInitialValue.tab8Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab8Status.color}
          action={action}
        />
      ),
      tabValueContain: <FirmDoctorList fullLength={true} firmId={values.id} />,
    };
    tabs.push(fimrDoctors);
  }

  if (
    (action === ACTIONS.EDIT || action === ACTIONS.VIEW) &&
    ((roles[0] === USERTYPES.FIRMADMIN && !ownFirm) ||
      roles[0] === USERTYPES.SUPERVISOR)
  ) {
    const configureSettings = {
      selectedKey: tabCount,
      tabName: `${t("hospital.configure-settings")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.configure-settings")}
          subtitle={t("sub-title.client.configure-settings")}
          iconName={errorContactState.tabStatusInitialValue.tab9Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab9Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <ConfigureSettings
          key={tabCount++}
          firmId={values.id}
          action={action}
          values={values}
          errorState={errorContactState.configureSettings}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          state={state}
          firmGlobalErrorState={firmGlobalErrorState}
          firmType={firmType}
        />
      ),
    };
    tabs.push(configureSettings);

    if (firmType === 1) {
      const configureClientaccess = {
        selectedKey: tabCount,
        tabName: `${t("hospital.configure-client-access")}`,
        tabKeyContain: (
          <CustomTab
            orderNumber={tabCount}
            tabName={t("hospital.configure-client-access")}
            subtitle={t("sub-title.client.conf-client-access")}
            iconName={errorContactState.tabStatusInitialValue.tab13Status.value}
            iconColor={
              errorContactState.tabStatusInitialValue.tab13Status.color
            }
            action={action}
          />
        ),
        tabValueContain: (
          <ConfigureClientAccess
            key={tabCount++}
            firmId={values.id}
            action={action}
            values={values}
            errorState={errorContactState.configureSettings}
            handleChange={handleChange}
            handleBlur={handleBlur}
            touched={touched}
            state={state}
            modalityList={modalityList}
            historyModalityList={historyModalityList}
            selectedSupervisorMap={selectedSupervisorMap}
            setSelectedSupervisorMap={setSelectedSupervisorMap}
            supervisorList={supervisorList}
            setSupervisorList={setSupervisorList}
            checkAllSupervisor={checkAllSupervisor}
            setCheckAllSupervisor={setCheckAllSupervisor}
            tabStatusInitialValue={tabStatusInitialValue}
            setTabStatusInitialValue={setTabStatusInitialValue}
            firmListForProviders={firmListForProviders}
            hospitalCheckList={hospitalCheckList}
            setHospitalCheckList={setHospitalCheckList}
          />
        ),
      };
      tabs.push(configureClientaccess);
    }

    const otherSettings = {
      selectedKey: tabCount,
      tabName: `${t("hospital.other-settings")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.other-settings")}
          subtitle={t("sub-title.client.other-settings")}
          iconName={errorContactState.tabStatusInitialValue.tab10Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab10Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <OtherSettings
          key={tabCount++}
          firmId={values.id}
          action={action}
          values={values}
          errorState={errorContactState.otherSettings}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          state={state}
          modalityList={modalityList}
          historyModalityList={historyModalityList}
        />
      ),
    };
    if (!viewWarningOnly && firmType === 0) {
      tabs.push(otherSettings);
    }

    const configureRadiologistAccess = {
      selectedKey: tabCount,
      tabName: `{t("hospital.configure-radiologist-access")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.configure-radiologist-access")}
          subtitle={t("sub-title.client.conf-radiologist-access")}
          iconName={errorContactState.tabStatusInitialValue.tab11Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab11Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <ConfigureRadiologistAccess
          key={tabCount++}
          firmId={values.id}
          action={action}
          values={values}
          errorState={errorContactState.configureSettings}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          state={state}
          modalityList={modalityList}
          historyModalityList={historyModalityList}
          selectedRadiologistMap={selectedRadiologistMap}
          setSelectedRadiologistMap={setSelectedRadiologistMap}
          radiologistList={radiologistList}
          setRadiologistList={setRadiologistList}
          checkAllRadiologist={checkAllRadiologist}
          setCheckAllRadiologist={setCheckAllRadiologist}
          tabStatusInitialValue={tabStatusInitialValue}
          setTabStatusInitialValue={setTabStatusInitialValue}
        />
      ),
    };
    if (!viewWarningOnly && firmType === 0) {
      tabs.push(configureRadiologistAccess);
    }

    const configureSupervisorAccess = {
      selectedKey: tabCount,
      tabName: `${t("hospital.configure-supervisor-access")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.configure-supervisor-access")}
          subtitle={t("sub-title.client.conf-supervisor-access")}
          iconName={errorContactState.tabStatusInitialValue.tab12Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab12Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <ConfigureSupervisorAccess
          key={tabCount++}
          firmId={values.id}
          action={action}
          values={values}
          errorState={errorContactState.configureSettings}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          state={state}
          modalityList={modalityList}
          historyModalityList={historyModalityList}
          selectedSupervisorMap={selectedSupervisorMap}
          setSelectedSupervisorMap={setSelectedSupervisorMap}
          supervisorList={supervisorList}
          setSupervisorList={setSupervisorList}
          checkAllSupervisor={checkAllSupervisor}
          setCheckAllSupervisor={setCheckAllSupervisor}
          tabStatusInitialValue={tabStatusInitialValue}
          setTabStatusInitialValue={setTabStatusInitialValue}
        />
      ),
    };
    if (!viewWarningOnly && firmType === 0) {
      tabs.push(configureSupervisorAccess);
    }

    const configureAutoAssignmentAccess = {
      selectedKey: tabCount,
      tabName: t("hospital.auto-assignment-settings"),
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount}
          tabName={t("hospital.auto-assignment-settings")}
          subtitle="Manage your auto assignment settings"
          iconName={errorContactState.tabStatusInitialValue.tab13Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab13Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <AutoAssignmentAccess
          key={tabCount++}
          firmId={values.id}
          action={action}
          values={values}
          errorState={errorContactState.autoAssignSettings}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          state={state}
          modalityList={modalityList}
          modalityWithSubModalityList={modalityWithSubModalityList}
          historyModalityList={historyModalityList}
          selectedModalityAndSubModality={selectedModalityAndSubModality}
          setSelectedModalityAndSubModality={setSelectedModalityAndSubModality}
        />
      ),
    };
    if (!viewWarningOnly && firmType === 0) {
      tabs.push(configureAutoAssignmentAccess);
    }
  }

  if (
    (action === ACTIONS.VIEW || action === ACTIONS.EDIT) &&
    roles[0] === USERTYPES.ADMIN &&
    !isMinimalAccount &&
    !values.isClientWarning &&
    !ownFirm
  ) {
    const firmAdmin = {
      selectedKey: tabCount,
      tabName: `{t("hospital.firm-admin")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount++}
          tabName={t("hospital.firm-admin")}
          iconName={errorContactState.tabStatusInitialValue.tab15Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab15Status.color}
          action={action}
        />
      ),
      tabValueContain: (
        <FirmAdminUserList
          fullLength={true}
          fullLengthForRow={false}
          firmId={values.id}
        />
      ),
    };

    tabs.push(firmAdmin);
  }

  if (
    (action === ACTIONS.VIEW || action === ACTIONS.EDIT) &&
    roles[0] === USERTYPES.ADMIN &&
    !isMinimalAccount &&
    !values.isClientWarning &&
    !ownFirm
  ) {
    const supervisor = {
      selectedKey: tabCount,
      tabName: `{t("hospital.supervisor")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount++}
          tabName={t("hospital.supervisor")}
          iconName={errorContactState.tabStatusInitialValue.tab16Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab16Status.color}
          action={action}
        />
      ),
      tabValueContain: <SupervisorList fullLength={true} firmId={values.id} />,
    };

    tabs.push(supervisor);
  }

  if (
    (action === ACTIONS.VIEW || action === ACTIONS.EDIT) &&
    roles[0] === USERTYPES.ADMIN &&
    !isMinimalAccount &&
    !values.isClientWarning &&
    !ownFirm
  ) {
    const typist = {
      selectedKey: tabCount,
      tabName: `{t("typist.typists")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount++}
          tabName={t("typist.typists")}
          // iconName={errorContactState.tabStatusInitialValue.tab17Status.value}
          // iconColor={errorContactState.tabStatusInitialValue.tab17Status.color}
          action={action}
        />
      ),
      tabValueContain: <TypistList fullLength={true} firmId={values.id} />,
    };

    tabs.push(typist);
  }
    
  if (process.env.REACT_APP_VDC_PLATFORM == "true" && ((roles[0] === USERTYPES.ADMIN && !isMinimalAccount) ||
       (roles[0] === USERTYPES.FIRMADMIN && ownFirm && action !== ACTIONS.ADD)
      ) &&
      roles[0] != USERTYPES.SUPERVISOR &&
      roles[0] != USERTYPES.FIRMDOCTOR &&
      roles[0] != USERTYPES.FIRMTECHNICIAN) {
    const configurePacs = {
      selectedKey: tabCount,
      tabName: `{t("hospital.configure-pacs")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount++}
          tabName={t("hospital.configure-pacs")}
          iconName={errorContactState.tabStatusInitialValue.tab17Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab17Status.color}
          action={action}
        />
      ),
      tabValueContain: <ConfigurePacs 
        pacsNodeList={pacsNodeList} 
        setPacsNodeList={setPacsNodeList}
        action={action}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errorState={errorContactState.pacsNodeConfig}
      />,
    };

    tabs.push(configurePacs);
  }

  if (process.env.REACT_APP_VDC_PLATFORM == "true" && (roles[0] === USERTYPES.FIRMADMIN && (isMinimalAccount))
      &&
      roles[0] != USERTYPES.SUPERVISOR &&
      roles[0] != USERTYPES.FIRMDOCTOR &&
      roles[0] != USERTYPES.FIRMTECHNICIAN) {
    const configurePacsAccess = {
      selectedKey: tabCount,
      tabName: `{t("hospital.configure-pacs-access")}`,
      tabKeyContain: (
        <CustomTab
          orderNumber={tabCount++}
          tabName={t("hospital.configure-pacs-access")}
          iconName={errorContactState.tabStatusInitialValue.tab16Status.value}
          iconColor={errorContactState.tabStatusInitialValue.tab16Status.color}
          action={action}
        />
      ),
      tabValueContain: <ConfigurePacsAccess 
        action={action}
        availablePacsList={availablePacsList} 
        setAvailablePacsList={setAvailablePacsList}
        checkAllPacs={checkAllPacs} 
        setCheckAllPacs={setCheckAllPacs}
        selectedPacsList={selectedPacsList} 
        setSelectedPacsList={setSelectedPacsList}
      />,
    };

    tabs.push(configurePacsAccess);
  }

  return tabs;
};
